import { createIcon } from '../create-icon'

// Castle/tower — objective control and structural advantage
export const GpiObjectives = createIcon('GpiObjectives', ({ strokeWidth }) => (
  <>
    <path d="M22 20H2" strokeWidth={strokeWidth} />
    <path d="M6 20V10l6-4 6 4v10" strokeWidth={strokeWidth} />
    <path d="M10 20v-4h4v4" strokeWidth={strokeWidth} />
    <path d="M4 10v-2h2" strokeWidth={strokeWidth} />
    <path d="M18 10v-2h2" strokeWidth={strokeWidth} />
    <path d="M12 6V4" strokeWidth={strokeWidth} />
  </>
))
